<div class="container" *ngIf="paymentData">
  <div class="info-co">
    <p class="info-title">Payable Amount:</p>
    <div class="info-context">
      <p class="value-suffix">{{ paymentData.currency.symbol }}</p>
      <p class="primary-value">
        {{ paymentData.order.payablePrice | convertPrice }}
      </p>
    </div>
  </div>
  <div class="cta-container">
    <gift-drawer-button></gift-drawer-button>
    <button
      mat-button
      class="custom-full-button"
      [disabled]="!paymentData.isValid || !paymentData.order.basePrice"
      (click)="goToCheckout()"
    >
      Buy Now
    </button>
  </div>
</div>
